'use client';

import { c as _c } from "react/compiler-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import Image from 'next/image';
import { useRef } from 'react';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from './CouponPrivacyProvideModal.module.scss';
import PrivacyProvideCoupon from './PrivacyProvideCoupon';
interface CouponPrivacyProvideModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
function CouponPrivacyProvideModal(t0) {
  const $ = _c(16);
  const {
    isOpen,
    onClose
  } = t0;
  const isClosingRef = useRef(false);
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      if (isClosingRef.current) {
        return;
      }
      isClosingRef.current = true;
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  let t2;
  if ($[2] !== handleClose) {
    t2 = open => !open && handleClose();
    $[2] = handleClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dialog.Overlay className={styles.overlay} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Dialog.Title asChild={true}><Text as="h3" category="heading" variant="sb1" color="var(--color-gray-700)">[필수] 개인정보 수집 · 이용 동의​</Text></Dialog.Title>;
    t5 = <Dialog.Description className="sr-only">[필수] 개인정보 수집 · 이용 동의​</Dialog.Description>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.titleContent}>{t4}{t5}<Dialog.Close asChild={true}><button type="button" className={styles.closeButton}><Image src="/cc/image/icon_X.svg" alt="close" fill={true} /></button></Dialog.Close></div>;
    t7 = <PrivacyProvideCoupon />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text category="button" variant="sb2" color="var(--color-gray-0)">확인</Text>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== handleClose) {
    t9 = <Dialog.Portal>{t3}<Dialog.Content className={styles.content}>{t6}{t7}<div className={styles.buttonContent}><button type="button" className={styles.confirmButton} onClick={handleClose}>{t8}</button></div></Dialog.Content></Dialog.Portal>;
    $[10] = handleClose;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isOpen || $[13] !== t2 || $[14] !== t9) {
    t10 = <Dialog.Root open={isOpen} onOpenChange={t2}>{t9}</Dialog.Root>;
    $[12] = isOpen;
    $[13] = t2;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}
export default CouponPrivacyProvideModal;